<template>
  <div>
    <div class="content1 flex flex-column flex-align-center">
      <header-component pageType="write"  :menuIndex="1"/>
      <div class="txt1" data-aos="fade-up">{{ $t('solution4.content1.title') }}</div>
      <div class="txt2" data-aos="fade-up" data-aos-delay="100" v-html="$t('solution4.content1.desc')"></div>
      <div class="ty" data-aos="fade-up" data-aos-delay="200" @click="$refs.connectRef.toConnectIndex()">{{ $t('solution4.content1.btn') }}</div>
    </div>
    <div class="content2 flex flex-column flex-align-center">
      <div class="txt1" data-aos="fade-up">{{ $t('solution4.content2.title') }}</div>
      <div class="txt2" data-aos="fade-up" data-aos-delay="100" v-html="$t('solution4.content2.desc')"></div>
      <div class="item1 flex flex-justify-between flex-align-center">
        <div class="l" data-aos="fade-up" data-aos-delay="200">
          <div class="txt3" @click="$refs.connectRef.toConnectIndex()">{{ $t('solution4.content2.item1.btn') }}</div>
          <div class="txt4" v-html="$t('solution4.content2.item1.desc')"></div>
        </div>
        <div class="r flex flex-column " data-aos="fade-up" data-aos-delay="300">
          <div class="txt5">{{ $t('solution4.content2.item1.title') }}</div>
          <ul>
            <li v-for="(item, index) in item1List" :key="'i1'+index">{{ item }}</li>
          </ul>
        </div>
      </div>
      <div class="item2 flex flex-justify-between flex-align-center">
        <div class="l" data-aos="fade-up">
          <div class="txt5">{{ $t('solution4.content2.item2.title') }}</div>
          <ul>
            <li v-for="(item, index) in item2List" :key="'i2'+index">{{ item }}</li>
          </ul>
        </div>
        <div class="r flex flex-column " data-aos="fade-up" data-aos-delay="100">
          <div class="txt3" @click="$refs.connectRef.toConnectIndex()">{{ $t('solution4.content2.item2.btn') }}</div>
        </div>
      </div>
      <div class="item3 flex flex-justify-between flex-align-center">
        <div class="l" data-aos="fade-up"></div>
        <div class="r flex flex-column " data-aos="fade-up" data-aos-delay="200">
          <div class="txt5">{{ $t('solution4.content2.item3.title') }}</div>
          <ul>
            <li v-for="(item, index) in item3List" :key="'i3'+index">{{ item }}</li>
          </ul>
          <div class="ty" @click="$refs.connectRef.toConnectIndex()">{{ $t('solution4.content2.item3.btn') }}</div>
        </div>
      </div>
    </div>
    <connect-component ref="connectRef" @kf="$refs.connectRef.toConnectIndex()"></connect-component>
    <kf-component kf-top="1086px" ref="kfContainer"></kf-component>
  </div>
</template>
<script>
export default {
  name: 'solution1-page',
  data() {
    return {
      
    }
  },
  computed: {
    item1List() {
      return this.$t('solution4.content2.item1.list')
    },
    item2List() {
      return this.$t('solution4.content2.item2.list')
    },
    item3List() {
      return this.$t('solution4.content2.item3.list')
    }
  }
}
</script>
<style lang="less" scoped>
.header-container2{
  box-shadow: none !important;
}
.content1{
  width: 1440px;
  min-height: 1069px;
  background: url('@/assets/image/solution4/Slice 37@2x.png') no-repeat center/cover;
  margin: 0 auto;
  .txt1{
    color: #000000;
    font-size: 60px;
    line-height: 90px;
    font-weight: bold;
    text-align: center;
    margin: 120px 0 0;
  }
  .txt2{
    font-family: Inter, Inter;
    font-weight: 400;
    font-size: 20px;
    color: #979797;
    line-height: 30px;
    max-width: 651px;
    text-align: center;
    margin-top: 20px;
  }
  .ty{
    margin: 37px 0 0 ;
    width: 257px;
    height: 44px;
    line-height: 44px;
    background: #FFFFFF;
    border-radius: 62px 62px 62px 62px;
    font-family: Inter, Inter;
    font-weight: bold;
    font-size: 17px;
    color: #000000;
    letter-spacing: 3px;
    text-align: center;
    cursor: pointer;
  }
}
.content2{
  margin: 144px auto 60px;
  .txt1{
    font-family: Inter, Inter;
    font-size: 40px;
    color: #000000;
    line-height: 60px;
    font-weight: bold;
    margin-bottom: 30px;
  }
  .txt2{
    font-family: Inter, Inter;
    font-weight: 400;
    font-size: 20px;
    color: #979797;
    line-height: 36px;
    text-align: center;
  }
  .item1{
    margin-top: 140px;
    .l{
      width: 492px;
      min-height: 572px;
      background: url('@/assets/image/solution4/Slice 46@2x.png') no-repeat center/100% 100%;
      position: relative;
      padding: 82px 0 0 89px;
      .txt3{
        width: 215px;
        height: 58px;
        line-height: 58px;
        background: linear-gradient( 157deg, #545AE7 0%, #393FCF 100%);
        border-radius: 60px 60px 60px 60px;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 22px;
        color: #FFFFFF;
        text-align: center;
        margin-bottom: 34px;
        cursor: pointer;
      }
      .txt4{
        font-family: Poppins, Poppins;
        font-weight: 600;
        font-size: 31px;
        color: #7E81CF;
        line-height: 50px;
      }
    }
    .r{
      margin-left: 130px;
      .txt5{
        font-family: Inter, Inter;
        font-weight: bold;
        font-size: 40px;
        color: #000000;
        margin-bottom: 62px;
      }
      ul,li{
        list-style: unset;
      }
      li{
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 20px;
        color: #51545A;
        line-height: 36px;
        margin-bottom: 50px;
        max-width: 430px;
      }
    }
  }
  .item2{
    margin-top: 140px;
    .l{
      .txt5{
        font-family: Inter, Inter;
        font-weight: bold;
        font-size: 40px;
        color: #000000;
        margin-bottom: 62px;
      }
      ul,li{
        list-style: unset;
      }
      li{
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 20px;
        color: #51545A;
        line-height: 36px;
        margin-bottom: 50px;
        max-width: 479px;
      }
    }
    .r{
      width: 821px;
      min-height: 576px;
      background: url('@/assets/image/solution4/Slice 46@2x(1).png') no-repeat center/100% 100%;
      position: relative;
      .txt3{
        width: 215px;
        height: 58px;
        background: linear-gradient( 157deg, #545AE7 0%, #393FCF 100%);
        border-radius: 60px 60px 60px 60px;
        text-align: center;
        line-height: 58px;
        position: absolute;
        right: 85px;
        bottom: 61px;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 22px;
        color: #FFFFFF;
        cursor: pointer;
      }
    }
  }
  .item3{
    margin-top: 140px;
    .l{
      width: 781px;
      min-height: 566px;
      background: url('@/assets/image/solution4/Slice 46@2x(2).png') no-repeat center/100% 100%;
      position: relative;
    }
    .r{
      margin-left: 130px;
      .txt5{
        font-family: Inter, Inter;
        font-weight: bold;
        font-size: 40px;
        color: #000000;
        margin-bottom: 62px;
      }
      ul,li{
        list-style: unset;
      }
      li{
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 20px;
        color: #51545A;
        line-height: 36px;
        margin-bottom: 50px;
        max-width: 430px;
      }
      .ty{
        width: 215px;
        height: 58px;
        background: linear-gradient( 157deg, #545AE7 0%, #393FCF 100%);
        border-radius: 60px 60px 60px 60px;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 22px;
        color: #FFFFFF;
        text-align: center;
        line-height: 58px;
        cursor: pointer;
      }
    }
  }
}
</style>